export default __webpack_public_path__ + "static/P_SearchThumb_IN-9008HD_Downloads-debc27e0ba820411abce328319e45d7b.webp";